import Marquee from "react-fast-marquee";

const WORDS = ["Personalizzazione", "Tecnica", "Programmazione", "Progressione", "Costanza", "Flessibilità", "Monitoraggio"];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-line bg-ink py-8" data-testid="editorial-marquee">
      <Marquee speed={30} gradient={false}>
        {WORDS.map((w, i) => (
          <span key={w} className="mx-8 flex items-center gap-8">
            <span className={`font-display text-3xl md:text-4xl ${i % 2 ? "italic text-mist" : "text-ivory/80"}`}>
              {w}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-sage" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
